import { render, staticRenderFns } from "./EventsAll.vue?vue&type=template&id=2098880a&scoped=true&"
import script from "./EventsAll.vue?vue&type=script&lang=ts&"
export * from "./EventsAll.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2098880a",
  null
  
)

export default component.exports